import LessonRow from "./LessonRow";

export default function ModuleAccordion({ module: mod, idx, isOpen, onToggleOpen, doneIds, busyId, onToggleLesson }) {
  const lessons = mod.lessons || [];
  const moduleDone = lessons.filter((l) => doneIds.includes(l.id)).length;
  const pct = lessons.length ? Math.round((moduleDone / lessons.length) * 100) : 0;

  return (
    <div className="flat-card" data-testid={`module-${idx + 1}`}>
      <button
        onClick={() => onToggleOpen(mod.id)}
        className="w-full text-left p-5 flex items-center justify-between gap-4"
        data-testid={`module-toggle-${idx + 1}`}
      >
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <span className="font-mono text-xs text-[var(--text-2)]">MOD-{String(idx + 1).padStart(2, "0")}</span>
            <h3 className="font-display font-bold text-xl uppercase">{mod.title}</h3>
          </div>
          {mod.description && <p className="text-sm text-[var(--text-2)] mt-1">{mod.description}</p>}
          <div className="flex items-center gap-3 mt-3">
            <div className="progress-track flex-1 max-w-md">
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="font-mono text-xs text-[var(--text-2)]">
              {moduleDone}/{lessons.length} &middot; {mod.duration_min}m
            </div>
          </div>
        </div>
        <span className="font-mono text-[var(--cyan)] text-2xl">{isOpen ? "−" : "+"}</span>
      </button>

      {isOpen && (
        <div className="border-t border-[var(--border)] divide-y divide-[var(--border)]" data-testid={`module-body-${idx + 1}`}>
          {lessons.map((l, li) => (
            <LessonRow
              key={l.id}
              moduleId={mod.id}
              lesson={l}
              lessonIdx={li}
              modIdx={idx}
              isDone={doneIds.includes(l.id)}
              isBusy={busyId === l.id}
              onToggle={onToggleLesson}
            />
          ))}
          {lessons.length === 0 && (
            <div className="px-5 py-4 text-sm text-[var(--text-2)]">No lessons in this module yet.</div>
          )}
        </div>
      )}
    </div>
  );
}
